import { render, staticRenderFns } from "./mentionTabCard.vue?vue&type=template&id=18109320&scoped=true&"
import script from "./mentionTabCard.vue?vue&type=script&lang=ts&"
export * from "./mentionTabCard.vue?vue&type=script&lang=ts&"
import style0 from "./mentionTabCard.vue?vue&type=style&index=0&id=18109320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18109320",
  null
  
)

export default component.exports